import * as Sentry from '@sentry/vue'
import { isDev } from '@/utils/environment'

export function setUser({ id, email }: any) {
  if (isDev) return

  Sentry.setUser({ id, email })
}

export function setTag({ key, value }: any) {
  if (isDev) return

  Sentry.setTag(key, value)
}

export function setTags(tags: any) {
  if (isDev) return

  Sentry.setTags(tags)
}
